import Swiper from "swiper"
import {SwiperOptions} from "swiper/types"
import {Keyboard, Navigation} from "swiper/modules"

const foodMenuGroups = document.querySelectorAll<HTMLElement>(".g-food-menu")

foodMenuGroups.forEach((group) => {
  const slider = group.querySelector<HTMLElement>(".g-food-menu__slider")

  if (!slider) return

  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, Navigation],
    slidesPerView: 1,
    spaceBetween: 8,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: group.querySelector<HTMLElement>(".g-food-menu__button.--next"),
      prevEl: group.querySelector<HTMLElement>(".g-food-menu__button.--prev"),
    },
    on: {
      init: () => {
        slider.classList.remove("--loading")
      },
    },
  }

  new Swiper(slider, swiperSettings)
})
